<template>
	<div class="lecturers">
		<div class="head">
			<md-button class="md-raised" v-on:click.native="showEditor">Előadó hozzáadása</md-button>
		</div>
		<div class="lecturer-row card row between-md middle-md" v-for="lecturer in lecturers">
			<span class="col-md-10">{{lecturer.name}}</span>
			<div class="col-md-2">
				<a v-on:click="edit(lecturer)"><md-icon>create</md-icon></br></a>
				<a v-on:click="remove(lecturer)"><md-icon>remove_circle_outline</md-icon></a>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import FirebaseDBService from '../../services/FirebaseDBService'
	import moment from 'moment'
	import _ from 'lodash'

	export default {
		data () {
			return {
				lecturers: []
			}
		},
		methods: {
			showEditor(){
				this.$router.push({ name: 'admin-editor', query: { type: 'lecturer' }});
			},
			edit: function(lecturer){
				this.$router.push({ name: 'admin-editor', query: { type: 'lecturer', id: lecturer.fireId }});	
			},
			remove: function(lecturer){
				FirebaseDBService.deleteLecturer(lecturer);
			}
		},
		mounted(){
			FirebaseDBService.getLecturers((err, lecturers) => {
				this.lecturers = _.sortBy(lecturers, "name");
			});
		}
	}
</script>

<style scoped>
	h1, h2 {
		font-weight: normal;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #F0AA57;
	}
</style>



// WEBPACK FOOTER //
// LecturersView.vue?53d18ca8